import { Form } from 'antd';
import { Modal } from 'components';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
export const BookingModalViewCalculation = ({
  onClose,
}: {
  onClose: () => void;
  onSuccess: any;
  id: any;
}) => {
  const [form] = Form.useForm();
  const formName = 'edit-user-form';

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        className='right-modal cstmmdlright'
        centered
        title={'Booking Report Rule'}
        onCancel={() => {
          document.body.style.overflow = 'auto';
          onClose(); // Call onClose function
        }}
        getContainer={false}
        onOk={form.submit}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{
          form: formName,
        }}
      >
        {/* <BookinginfoCalculation form={form} /> */}
      </Modal>
    </StyledUserModalWrapper>
  );
};
